interface Props {
  qty: number;
  onChange: (qty: number) => void;
  max?: number;
  disabled?: boolean;
}

export function QtyStepper({ qty, onChange, max, disabled }: Props) {
  const atMax = max != null && qty >= max;
  return (
    <div className="inline-flex items-center rounded-lg border border-brand/20 bg-white">
      <button
        type="button"
        aria-label="decrease"
        className="h-10 w-10 text-xl font-bold text-brand disabled:opacity-30"
        onClick={() => onChange(qty - 1)}
        disabled={disabled || qty <= 0}
      >
        −
      </button>
      <span className="min-w-9 text-center text-sm font-semibold tabular-nums">{qty}</span>
      <button
        type="button"
        aria-label="increase"
        className="h-10 w-10 text-xl font-bold text-brand disabled:opacity-30"
        onClick={() => onChange(qty + 1)}
        disabled={disabled || atMax}
      >
        +
      </button>
    </div>
  );
}
